import React from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import EmailVerificationBanner from './EmailVerificationBanner';

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-background-light dark:bg-background-dark grain-overlay">
      <Navbar />
      <main className="flex-1 pt-16">
        <EmailVerificationBanner />
        {children}
      </main>
      <Footer />
    </div>
  );
};
